import React, { FC, useEffect, useRef } from 'react';
import { useLanguage } from 'context/AppContext';
import ConfirmModal from './ConfirmModal';

interface DuplicateMergeModalProps {
  open: boolean;
  close: () => void;
  confirm: () => void;
  tray: string;
  codes: string[];
}

// Merge/Cancel prompt shown when devices being added or moved already exist in the tray
const DuplicateMergeModal: FC<DuplicateMergeModalProps> = ({ open, close, confirm, tray, codes }) => {
  const [language] = useLanguage();
  // Merge sums quantities, so a second click while the dialog fades out must not merge again
  const confirmed = useRef(false);

  useEffect(() => {
    if (open) confirmed.current = false;
  }, [open]);

  const confirmOnce = (): void => {
    if (confirmed.current) return;
    confirmed.current = true;
    confirm();
  };

  return (
    <ConfirmModal
      open={open}
      close={close}
      confirm={confirmOnce}
      confirmText={`${language.ConfirmModal.duplicateIn} ${tray}: ${codes.join(', ')}. ${
        language.ConfirmModal.duplicateMerge
      }`}
      buttonText={language.ConfirmModal.merge}
      cancelText={language.ConfirmModal.cancel}
    />
  );
};

export default DuplicateMergeModal;
